import { z } from 'zod'

// Accepteer cuid (post-2026-04 records) én UUID v4 (legacy geïmporteerd).
// Migratie van legacy UUID → cuid is niet veilig zonder FK-impact-analyse,
// dus validatie moet beide accepteren. Strenger dan vrije string om
// injection/typos te catchen.
// Eerste teken is een wíllekeurige letter, niet alleen 'c': naast Prisma-cuid
// v1 ('c'-prefix) genereren batched creates ids client-side met `createId()`
// van @paralleldrive/cuid2 (o.a. werkbonnen sinds 2026-05-15 — 88% van de
// prod-werkbonnen). Een 'c'-only regex weigerde die ids onterecht.
const CUID_RE = /^[a-z][a-z0-9]{8,}$/i
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
// Seed-records krijgen een handgeschreven id (bijv. de operationele BV's:
// `seed_entity_service`) i.p.v. een cuid. Die ids zijn FK's door de hele
// database (medewerkers, werkbonnen, facturen, offertes, tarieven, IC) en
// kunnen niet veilig hernoemd worden zonder FK-impact-analyse — dus de
// validator accepteert ze als geldig prod-id, net als legacy-UUID's.
const SEED_RE = /^seed_[a-z0-9_]+$/i

export const idParam = (label = 'id') =>
  z.string().refine(
    (v) => CUID_RE.test(v) || UUID_RE.test(v) || SEED_RE.test(v),
    { message: `${label} moet een geldig cuid of uuid zijn` },
  )
